import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from "react";

type AppealIdContextValue = {
  appealId: string | null;
  setAppealId: (id: string) => void;
  removeAppealId: () => void;
};

const AppealIdContext = createContext<AppealIdContextValue | null>(null);

type AppealIdProviderProps = {
  children: ReactNode;
};

export const AppealIdProvider = ({ children }: AppealIdProviderProps) => {
  const [appealId, setAppealIdState] = useState<string | null>(() => {
    const value = sessionStorage.getItem("appealId");
    return value;
  });

  const setAppealId = useCallback((id: string) => {
    sessionStorage.setItem("appealId", id);
    setAppealIdState(id);
  }, []);

  const removeAppealId = useCallback(() => {
    sessionStorage.removeItem("appealId");
    setAppealIdState(null);
  }, []);

  const value = {
    appealId,
    setAppealId,
    removeAppealId,
  };

  return (
    <AppealIdContext.Provider value={value}>
      {children}
    </AppealIdContext.Provider>
  );
};

export const useAppealIdFromSession = () => {
  const context = useContext(AppealIdContext);

  if (!context) {
    throw new Error(
      "useAppealIdFromSession must be used within an AppealIdProvider",
    );
  }

  return context;
};
